import './App.css';
import FirstScreenRec from './AdminReceptionistScreens/FirstScreenRec';
import SecondScreenRec from './AdminReceptionistScreens/SecondScreenRec';
import ThirdScreenRec from './AdminReceptionistScreens/ThirdScreenRec';
import FourthScreenRec from './AdminReceptionistScreens/FourthScreenRec';
import FifthScreenRec from './AdminReceptionistScreens/FifthScreenRec';
import SixthScreenRec from './AdminReceptionistScreens/SixthScreenRec';
import AdminTestimonials from './AdminReceptionistScreens/AdminTestimonials';
import SeventhScreenRec from './AdminReceptionistScreens/SeventhScreenRec';
import EighthScreenRec from './AdminReceptionistScreens/EighthScreenRec';
import NinthScreenRec from './AdminReceptionistScreens/NinthScreenRec';
import TenthScreenRec from './AdminReceptionistScreens/TenthScreenRec';
import EleventhScreenRec from './AdminReceptionistScreens/EleventhScreenRec';
import ByMe from './components/ByMe/ByMe';
import FloatingWhatsAppButton from './components/FloatingButton/FloatingButton';
import PrivacyPolicy from './components/privacy/Privacy';

const AdminReceptionistWrapper=()=> {
  return <div style={{ overflowX: 'hidden' }}>
  <FirstScreenRec/>
  <SecondScreenRec/>
  <ThirdScreenRec/>
  <FourthScreenRec/>
  <SixthScreenRec/>
  <AdminTestimonials/>
  <SeventhScreenRec/>
  <EighthScreenRec/>
  <NinthScreenRec/>
  <TenthScreenRec/>
  <EleventhScreenRec/>
  <FifthScreenRec/>

<FloatingWhatsAppButton/>
    <PrivacyPolicy
                      ownerName="קרן אקסלרוד - המשרד"
                      email="Kerenaxelrod@gmail.com"
                      phone="+972 50-891-9747"
                      domain="https://hamisrad.co.il/"
                    />
<ByMe/>
  </div>
}

export default AdminReceptionistWrapper;
